module.exports = __webpack_public_path__ + "img/tab-history.d1596122.png";